import {ErrorHandler, NgModule} from '@angular/core';
import {BrowserModule, HAMMER_GESTURE_CONFIG} from '@angular/platform-browser';
import {RouteReuseStrategy} from '@angular/router';

import {IonicModule, IonicRouteStrategy} from '@ionic/angular';
import {SplashScreen} from '@ionic-native/splash-screen/ngx';
import {StatusBar} from '@ionic-native/status-bar/ngx';

import {AppRoutingModule} from '@app/app-routing.module';
import {AppComponent} from '@app/app.component';
import {BrowserAnimationsModule} from '@angular/platform-browser/animations';
import {SnackBar} from '@app/core/services/snackbar.service';
import 'hammerjs';
import {environment} from '@env/environment';
import {HttpService} from '@app/core/services/http.service';
import {HammerConfig} from '@app/support/HammerConfigShiftView';
import {SharedModule} from '@app/modules/shared/shared.module';
import {CoreModule} from '@app/core/core.module';
import {PrintService} from '@app/core/services/print.service';
import {TranslateLoader, TranslateModule} from '@ngx-translate/core';
import {TranslateHttpLoader} from '@ngx-translate/http-loader';
import {HttpClient} from '@angular/common/http';
import {InternationalizationService} from '@app/core/services/internationalization.service';
import packageJson from '../../package.json';
import {SentryErrorHandler} from '@app/sentry.error-handler';
import {LANGUAGE_SERVICE} from '@quickorder/angular-web-lib';

@NgModule({
	declarations: [
		AppComponent,
	],
	imports: [
		// Angular and Ionic
		BrowserModule,
		IonicModule.forRoot(),
		AppRoutingModule,
		BrowserAnimationsModule,
		BrowserModule,

		// Core and sharedModule
		SharedModule,
		CoreModule,
		// translation service
		TranslateModule.forRoot({
			loader: {
				provide: TranslateLoader,
				useFactory: (http: HttpClient) => new TranslateHttpLoader(http, './assets/i18n/', '.json?v=' + environment.prefixSentry + '.' + packageJson.version),
				deps: [HttpClient],
			},
		}),
	],
	providers: [
		StatusBar,
		SplashScreen,
		{provide: RouteReuseStrategy, useClass: IonicRouteStrategy},
		{provide: HAMMER_GESTURE_CONFIG, useClass: HammerConfig},
		HttpService,
		InternationalizationService,
		SnackBar,
		PrintService,
		{provide: ErrorHandler, useClass: SentryErrorHandler},
		{
			provide: LANGUAGE_SERVICE,
			useClass: InternationalizationService,
		},
	],
	bootstrap: [AppComponent],
})
export class AppModule {
}
